module.exports = __webpack_public_path__ + "img/0Q3A8493_L_Wood_MockedUp.b555462b.jpg";